import React, { Fragment } from "react";
import { Form, InputNumber, Select, Input, Popover, Icon } from "antd";
import filterConnect from "../../../../common/hoc/filterConnect";

const { Option } = Select;

const ServiceType = ({ form, disabled, serviceTypes }) => {
  const { getFieldDecorator, getFieldValue } = form;
  const currentServiceType = getFieldValue("serviceType");
  const passengerCode = getFieldValue("passengerCode");

  const popover = (
    <div className="popover-content">
      <p>ПП - Простая перевозка по заказу</p>
      <p>ОПГД - Организованная перевозка групп детей</p>
      <p>ПНКЛ - Перевозка неопределенного круга лиц</p>
    </div>
  );

  let totalPassengers = 0;
  let kidsCount =
      (getFieldValue("kidsCount") && parseInt(getFieldValue("kidsCount"))) || 0,
    accompCount =
      (getFieldValue("accompCount") &&
        parseInt(getFieldValue("accompCount"))) ||
      0,
    workersCount =
      (getFieldValue("workersCount") &&
        parseInt(getFieldValue("workersCount"))) ||
      0,
    medWorkersCount =
      (getFieldValue("medWorkersCount") &&
        parseInt(getFieldValue("medWorkersCount"))) ||
      0;

  totalPassengers = kidsCount + accompCount + workersCount + medWorkersCount;
  return (
    <Fragment>
      <div className="offer-card__item">
        <span className="label">Вид транспортной услуги:</span>
        <Form.Item>
          {getFieldDecorator("serviceType")(
            <Select
              getPopupContainer={trigger => trigger.parentNode}
              placeholder="Выберите вид транспортной услуги"
              showSearch
              style={{ width: 368 }}
              disabled={disabled}
            >
              {serviceTypes &&
                serviceTypes.map(item => {
                  let existAbbr = item.serviceType.match(/\(.*?\)/g);
                  return (
                    <Option
                      key={item.serviceTypeKey}
                      value={item.serviceTypeKey}
                    >
                      {existAbbr
                        ? item.serviceType
                        : item.serviceType + " (" + item.serviceTypeAbbr + ")"}
                    </Option>
                  );
                })}
            </Select>
          )}
        </Form.Item>
        <span className="extra-label additional-input">
          <span className="show-map">
            <Popover
              overlayClassName="order-popover"
              placement="topLeft"
              content={popover}
              trigger="click"
            >
              <Icon type="question-circle" />
            </Popover>
          </span>
        </span>
      </div>
      {currentServiceType === "kids" && (
        <>
          <div className="offer-card__item" style={{display: "flex", alignItems: "center"}}>
            <span className="label">Максимальное количество детей:</span>
            <Form.Item>
              {getFieldDecorator("kidsCount", {
                rules: [
                  {
                    required: true,
                    message: "Поле, обязательное для заполнения"
                  }
                ]
              })(
                <InputNumber
                  max={999}
                  min={1}
                  style={{ width: 80 }}
                  placeholder="Укажите"
                  disabled={disabled}
                />
              )}
            </Form.Item>
            <span>
              Общее число пассажиров:
              <span className="offer-card__addon"> {totalPassengers}</span>
            </span>
          </div>

          <div className="offer-card__item" style={{display: "flex", alignItems: "center"}}>
            <span className="label" style={{ letterSpacing: -1 }}>
              Максимальное количество сопровождающих:
            </span>
            <Form.Item>
              {getFieldDecorator("accompCount", {
                rules: [
                  {
                    required: true,
                    message: "Поле, обязательное для заполнения"
                  }
                ]
              })(
                <InputNumber
                  max={999}
                  min={1}
                  style={{ width: 80 }}
                  placeholder="Укажите"
                  disabled={disabled}
                />
              )}
            </Form.Item>
            {disabled && passengerCode && (
              <span>Код для пассажиров: <span className="offer-card__addon">{passengerCode}</span></span>
            )}
          </div>

          <div className="offer-card__item">
            <span className="label" style={{ letterSpacing: -1 }}>
              Макс. количество работников и(или) физ. лиц, участвующих в
              перевозке:
            </span>
            <Form.Item>
              {getFieldDecorator("workersCount")(
                <InputNumber
                  max={999}
                  min={1}
                  style={{ width: 80 }}
                  placeholder="Укажите"
                  disabled={disabled}
                />
              )}
            </Form.Item>
          </div>

          <div className="offer-card__item">
            <span className="label" style={{ letterSpacing: -1 }}>
              Максимальное количество мед. работников:
            </span>
            <Form.Item>
              {getFieldDecorator("medWorkersCount")(
                <InputNumber
                  max={999}
                  min={1}
                  style={{ width: 80 }}
                  placeholder="Укажите"
                  disabled={disabled}
                />
              )}
            </Form.Item>
          </div>

          <div
            className="offer-card__item"
            // style={{ backgroundColor: 'rgba(255,0,0,0.2)' }}
          >
            <span className="label" style={{ lineHeight: "normal" }}>
              E-mail отделения ГИБДД для отправки уведомления:
            </span>
            <Form.Item>
              {getFieldDecorator("gibddMail", {
                required: true,
                message: "Поле, обязательное для заполнения"
              })(
                <Input
                  disabled={disabled}
                  style={{ width: 368 }}
                  placeholder="Укажите e-mail"
                />
              )}
            </Form.Item>
          </div>
        </>
      )}
      {currentServiceType === "simple" && (
        <div className="offer-card__item">
          <span className="label">Количество пассажиров:</span>
          <Form.Item>
            {getFieldDecorator("passengersCount", {
              rules: [
                {
                  required: true,
                  message: "Поле, обязательное для заполнения"
                }
              ]
            })(
              <InputNumber
                max={999}
                min={1}
                style={{ width: 80 }}
                placeholder="Укажите"
                disabled={disabled}
              />
            )}
          </Form.Item>
          {disabled && passengerCode && (
            <span>Код для пассажиров: {passengerCode}</span>
          )}
        </div>
      )}
    </Fragment>
  );
};

export default filterConnect(ServiceType, ["serviceTypes"]);
